import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ChangePasswordProfileUseCaseInterface } from 'domain/usecases';

export class RemoteChangePasswordProfile
  implements ChangePasswordProfileUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: ChangePasswordProfileUseCaseInterface.Params,
  ): Promise<ChangePasswordProfileUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url + '/' + params.id,
      body: {
        password: params.password,
      },
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
